export default {"src":"/_next/static/media/changelog.af6c482e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};